var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.28699,
    y: 1.28711,
    width: 16.7143,
    height: 15.4286,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3368 15.3371H12.6698V11.1603C12.6698 10.1643 12.652 8.8822 11.2827 8.8822C9.8936 8.8822 9.68104 9.9674 9.68104 11.0878V15.3368H7.01409V6.74772H9.57438V7.92152H9.61024C9.86646 7.4834 10.2367 7.12299 10.6816 6.87865C11.1264 6.63432 11.6292 6.51522 12.1364 6.53404C14.8396 6.53404 15.338 8.3121 15.338 10.6252L15.3368 15.3371ZM4.00472 5.57371C3.14993 5.57385 2.45686 4.881 2.45672 4.02621C2.45658 3.17142 3.14937 2.47835 4.00415 2.47821C4.85894 2.478 5.55201 3.17086 5.55215 4.02564C5.55223 4.43613 5.38924 4.82984 5.09904 5.12015C4.80884 5.41047 4.4152 5.57362 4.00472 5.57371ZM5.33826 15.3372H2.66843V6.74772H5.33819V15.3371L5.33826 15.3372ZM16.6664 0.00131005H1.32827C0.603351 -0.00684619 0.00885937 0.573865 0 1.29879V16.7009C0.00857812 17.4262 0.603 18.0075 1.3282 17.9999H16.6664C17.3932 18.0089 17.9899 17.4276 18 16.7009V1.29759C17.9897 0.571263 17.3928 -0.00937744 16.6664 0.000114742",
    fill: "#0A66C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.d9a70e235dc13eacb3d5c490631bcf5c.svg";
export { ForwardRef as ReactComponent };